import { Skeleton } from "@mui/material";
import { CreateQuotePageContainer } from "pages/CustomQuote/CreateQuotePage/CreateQuotePage.styles";
import {
	DesignerRequestSKUSkeletonContainer,
	SkeletonContainer,
	SkeletonSectionContainer
} from "./CreateQuoteFormSkeleton.styles";

const CreateQuoteFormSkeleton = () => (
	<CreateQuotePageContainer data-testid="create-quote-page">
		<SkeletonSectionContainer
			square
			elevation={1}
		>
			<Skeleton
				variant="text"
				width="100%"
				height="76px"
			/>
			<DesignerRequestSKUSkeletonContainer>
				<SkeletonContainer>
					<Skeleton
						variant="text"
						width="100%"
						height="24px"
					/>
					<Skeleton
						variant="text"
						width="100%"
						height="16px"
					/>
				</SkeletonContainer>
				<SkeletonContainer>
					<Skeleton
						variant="text"
						width="100%"
						height="36px"
					/>
				</SkeletonContainer>
			</DesignerRequestSKUSkeletonContainer>
			<Skeleton
				variant="text"
				width="100%"
				height="128px"
			/>
		</SkeletonSectionContainer>
		<SkeletonSectionContainer
			square
			elevation={1}
		>
			<Skeleton
				variant="text"
				width="100%"
				height="42px"
			/>
			<Skeleton
				variant="text"
				width="100%"
				height="224px"
			/>
			<DesignerRequestSKUSkeletonContainer>
				<SkeletonContainer>
					<Skeleton
						variant="text"
						width="100%"
						height="36px"
					/>
					<Skeleton
						variant="text"
						width="100%"
						height="16px"
					/>
					<Skeleton
						variant="text"
						width="100%"
						height="16px"
					/>
				</SkeletonContainer>
			</DesignerRequestSKUSkeletonContainer>
		</SkeletonSectionContainer>
		<SkeletonSectionContainer
			square
			elevation={1}
		>
			<Skeleton
				variant="text"
				width="50%"
				height="42px"
			/>
			<Skeleton
				variant="text"
				width="100%"
				height="36px"
			/>
			<Skeleton
				variant="text"
				width="100%"
				height="36px"
			/>
		</SkeletonSectionContainer>
	</CreateQuotePageContainer>
);

export default CreateQuoteFormSkeleton;
